document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.getElementById('low-stock-notice-wrapper');
  if (!wrapper) return;

  var variantsData;
  try {
    variantsData = JSON.parse(wrapper.getAttribute('data-variants-json'));
  } catch (e) {
    return;
  }

  var noticeEl = document.getElementById('low-stock-notice');
  var countEl = document.getElementById('low-stock-count');

  function findCurrentVariantId() {
    // Search the whole document for any hidden input tracking the selected variant id
    var idInput = document.querySelector('.product-form__input input[name="id"]')
      || document.querySelector('form[action*="/cart/add"] input[name="id"]')
      || document.querySelector('input.product-variant-id')
      || document.querySelector('input[name="id"]');

    return idInput ? parseInt(idInput.value, 10) : null;
  }

  function updateLowStockNotice() {
    var variantId = findCurrentVariantId();
    if (!variantId) {
      noticeEl.style.display = 'none';
      return;
    }

    var variant = variantsData.find(function (v) {
      return v.id === variantId;
    });

    if (!variant) {
      noticeEl.style.display = 'none';
      return;
    }

    var qty = variant.inventory_quantity;
    var managed = variant.inventory_management !== null && variant.inventory_management !== '' && variant.inventory_management !== false;
    var available = variant.available;

    if (available && managed && qty > 0 && qty <= 3) {
      countEl.textContent = qty;
      noticeEl.style.display = 'block';
    } else {
      noticeEl.style.display = 'none';
    }
  }

  // Run once on load to sync with whatever variant is pre-selected
  updateLowStockNotice();

  // Listen for Dawn's native custom event (fires on most Dawn versions)
  document.addEventListener('variant:change', function () {
    setTimeout(updateLowStockNotice, 50);
  });

  // Listen for any radio/select change anywhere on the page (broad net, since picker location varies)
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (
      target.closest('fieldset') ||
      target.name === 'id' ||
      (target.name && target.name.indexOf('options') !== -1) ||
      target.tagName === 'SELECT'
    ) {
      setTimeout(updateLowStockNotice, 50);
    }
  });

  // Also catch plain clicks on variant swatch/button-style pickers (some Dawn versions use <button> or <label> not <input>)
  document.addEventListener('click', function (event) {
    if (event.target.closest('.product-form__input, variant-radios, variant-selects')) {
      setTimeout(updateLowStockNotice, 100);
    }
  });
});
